// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Arial, sans-serif;
}
 
.container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
 
 
.title-section h3{
  background-color: #6699cc;
  color: #ffffff;
  padding: 10px;
  text-align: left;
}
.effective-date {
  margin-bottom: 20px;
}
 
.employee-details-box {
  border: 1px solid #6699cc;
  padding: 20px;
  border-radius: 5px;
  width: 100%;
}
 
.info-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  font-weight: bold;
  width: 100%;
}
 
.authorities-codes {
  text-align: left;
}
 
.conversion-rate {
  text-align: right;
}
 
.cat-title {
  color: red;
}
 
.blue-text {
  color: #6699cc;
  font-weight: bold;
}
 
.button-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}
 
 @media print {
  body {
    visibility: hidden;
}
  .scrollable-container {
    overflow: visible !important;
    max-height: none !important;
  }
  .container, .container * {
    visibility: visible;
  }
  .container {
    position: absolute;
    transform: scale(0.30);
    transform-origin: top left;
  }
  .button-container, .no-print {
    display: none;
  }
  table {
    width: 100%;
    border-collapse: collapse;
  }
  table, th, td {
    border: 1px solid black;
    visibility: visible;
    display: table-cell;
  }
  th, td {
    padding: 8px;
    text-align: left;
  }
}
 
td a {
  color: blue;
  text-decoration: none;
}
.equals-symbol {
  color: black;
  margin-left: 2px;
}
.underline {
  text-decoration: underline;
  text-decoration-color: blue;
 
}
 
.type-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}
 
.type-name {
  flex: 1;
  display: flex;
  margin-bottom: 10px;
  position: relative;
}
 
.type-name strong {
  position: absolute;
  left: 0;
  top: 0;
  min-width: 50px;
}
 
.type-content {
  margin-left: 60px;
  white-space: normal;
  word-wrap: break-word;
  display: inline-block;
  text-indent: 0;
}
.type-dollar {
  flex: 0 0 180px;
  text-align: right;
}
 
.sub-cat-name {
  margin-bottom: 10px;
}
 
.cat-title {
  color: red;
}
 
.doa-dollar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
 
.dialog-content {
  max-height: calc(100vh - 210px);
  overflow-y: auto;
}
 
.scrollable-container {
  max-height: 100vh;
  overflow-y: auto;
}
 
.scrollable-container::-webkit-scrollbar {
  width: 12px;
}
 
.scrollable-container::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}
 
.scrollable-container::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
.bordered-container {
  border: 1px solid #d3d3d3;
  padding: 20px;
  max-width: 100%;
  margin: 3% 0%;
  border-radius: 1px;
}
 
.close-button {
  position: absolute;
  top: 10px;
  right: 20px;
  background: none;
  border: none;
  font-size: 24px;
  font-weight: bold;
  color: #000;
  cursor: pointer;
}
 
.close-button:hover {
  color: #ff0000;
}
 
.text-danger h3{
  color: red !important;
}


.table-wrapper {
  width: 100%;
  overflow-x: auto;
}


.doa-type-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.dollar-label {
  margin-left: auto;
  margin-right: -2%;
}
  
  `, "",{"version":3,"sources":["webpack://./src/app/modules/delegationofauthority/displaypage/displaypage.component.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;CAEC;EACC;IACE,kBAAkB;AACtB;EACE;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;;AAE7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":["body {\n  font-family: Arial, sans-serif;\n}\n \n.container {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n \n \n.title-section h3{\n  background-color: #6699cc;\n  color: #ffffff;\n  padding: 10px;\n  text-align: left;\n}\n.effective-date {\n  margin-bottom: 20px;\n}\n \n.employee-details-box {\n  border: 1px solid #6699cc;\n  padding: 20px;\n  border-radius: 5px;\n  width: 100%;\n}\n \n.info-line {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n  font-weight: bold;\n  width: 100%;\n}\n \n.authorities-codes {\n  text-align: left;\n}\n \n.conversion-rate {\n  text-align: right;\n}\n \n.cat-title {\n  color: red;\n}\n \n.blue-text {\n  color: #6699cc;\n  font-weight: bold;\n}\n \n.button-container {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 20px;\n}\n \n @media print {\n  body {\n    visibility: hidden;\n}\n  .scrollable-container {\n    overflow: visible !important;\n    max-height: none !important;\n  }\n  .container, .container * {\n    visibility: visible;\n  }\n  .container {\n    position: absolute;\n    transform: scale(0.30);\n    transform-origin: top left;\n  }\n  .button-container, .no-print {\n    display: none;\n  }\n  table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  table, th, td {\n    border: 1px solid black;\n    visibility: visible;\n    display: table-cell;\n  }\n  th, td {\n    padding: 8px;\n    text-align: left;\n  }\n}\n \ntd a {\n  color: blue;\n  text-decoration: none;\n}\n.equals-symbol {\n  color: black;\n  margin-left: 2px;\n}\n.underline {\n  text-decoration: underline;\n  text-decoration-color: blue;\n \n}\n \n.type-row {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 10px;\n}\n \n.type-name {\n  flex: 1;\n  display: flex;\n  margin-bottom: 10px;\n  position: relative;\n}\n \n.type-name strong {\n  position: absolute;\n  left: 0;\n  top: 0;\n  min-width: 50px;\n}\n \n.type-content {\n  margin-left: 60px;\n  white-space: normal;\n  word-wrap: break-word;\n  display: inline-block;\n  text-indent: 0;\n}\n.type-dollar {\n  flex: 0 0 180px;\n  text-align: right;\n}\n \n.sub-cat-name {\n  margin-bottom: 10px;\n}\n \n.cat-title {\n  color: red;\n}\n \n.doa-dollar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n \n.dialog-content {\n  max-height: calc(100vh - 210px);\n  overflow-y: auto;\n}\n \n.scrollable-container {\n  max-height: 100vh;\n  overflow-y: auto;\n}\n \n.scrollable-container::-webkit-scrollbar {\n  width: 12px;\n}\n \n.scrollable-container::-webkit-scrollbar-thumb {\n  background-color: #888;\n  border-radius: 10px;\n}\n \n.scrollable-container::-webkit-scrollbar-thumb:hover {\n  background-color: #555;\n}\n.bordered-container {\n  border: 1px solid #d3d3d3;\n  padding: 20px;\n  max-width: 100%;\n  margin: 3% 0%;\n  border-radius: 1px;\n}\n \n.close-button {\n  position: absolute;\n  top: 10px;\n  right: 20px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  font-weight: bold;\n  color: #000;\n  cursor: pointer;\n}\n \n.close-button:hover {\n  color: #ff0000;\n}\n \n.text-danger h3{\n  color: red !important;\n}\n\n\n.table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n}\n\n\n.doa-type-container {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.dollar-label {\n  margin-left: auto;\n  margin-right: -2%;\n}\n  \n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
